module.exports = __webpack_public_path__ + "img/forgotsideimage.0d88246e.png";